<template>
  <div v-loading="loading">
    <div class="thisTitle">
      <span class="thisIcon">
        <img v-if="scoreType==2" src="../../common/images/icon-xingjilogo.png" alt=""/>
        <img v-else src="../../common/images/icon-xinyonglogo.png" alt=""/>
      </span>
      <span v-if="scoreType==2">星级</span>
      <span v-else>信用</span>
    </div>

    <div class="starBody">
      <div class="starSet" v-for="item in mainData">
        <div class="starSetTitle">
          {{item.name}}
          <div class="valueSetting" v-if="item.onlyScore != -1">
            分值设定：<span style="margin-left: 10px">{{item.onlyScore}}</span>
          </div>
        </div>

        <div class="starSetTitleTag">
          <div v-for="item2 in item.type">
            <span class="tag-item" :class="{'long':item2=='长'}">{{item2}}</span>{{item2}}促
          </div>
        </div>

        <div class="starContainer" v-for="item2 in item.type">
          <div class="headPortrait">
            <span class="tag-item big" :class="{'short':item2=='短'}">{{item2}}</span>
            <span>{{item2}}促</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="list">
            <table>
              <tr>
                <th width="100">分值区间</th>
                <th v-for="item3 in (item2=='长' ? item.long : item.short)" class="wid130">
                  <span class="range">
                    <span>
                      {{item3.min}}<span v-if="item.name.indexOf('率') > -1">%</span><span v-else>分</span>
                    </span>-
                    <span>
                      {{item3.max}}<span v-if="item.name.indexOf('率') > -1">%</span><span v-else>分</span>
                    </span>
                  </span>
                </th>
              </tr>
              <tr>
                <td width="100">分值设定</td>
                <td v-for="item3 in (item2=='长' ? item.long : item.short)" class="wid130">
                  {{item3.score}}<span v-if="item.name.indexOf('率') > -1">%</span><span v-else>分</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!--如果本页载入星级页数据，则必有的星级设定，不参与上面的v-for-->
      <div class="starSet" v-if="scoreType==2">
        <div class="starSetTitle">星级设定</div>
        <div class="starContainer">
          <table class="wid100per">
            <tr>
              <th width="100px">分值区间</th>
              <th v-for="item in starSetArr" class="wid130">
                <span class="range">
                  <span>{{item.scoreMin}}</span>-
                  <span>{{item.scoreMax}}</span>
                </span>
              </th>
            </tr>
            <tr>
              <td>星级名称</td>
              <td v-for="(item,index) in starSetArr">
                <div>{{item.starName}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //韩金辰180724重写
  import utils from '../../common/js/util'

  export default {
    name: '',
    data() {
      return {
        loading:true,
        starSetArr: [],
        mainData: [],
      }
    },
    props:['scoreType'],
    mounted() {
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchScore',
        params: {
          startTime: this.$route.query.sTime,
          scoreType: this.scoreType
        }
      }).then(res => {
        let arr = []
        res.data.map(item => {
          let noSame = true;
          arr.map(item2 => {
            if (item2.masterId == item.masterId) {
              //signId还有可能是null，但这种情况不可能重复，所以不会进入masterId相等的判断
              noSame = false
              //先把min max等数据推进对应的数组，再更新type属性，有可能是全选
              let type = item.signId == 1 ? 'long' : 'short'
              item2[type].push({
                min: item.scoreMin,
                max: item.scoreMax,
                score: item.score,
              })
              let type2 = item.signId == 1 ? '长' : '短'
              if (item2.type.indexOf(type2) < 0) {
                item2.type.push(type2)
              }
            }
          })
          //如果arr中没有这个相同的item，则push进arr
          if (noSame) {
            let type = item.signId ? (item.signId == 1 ? ['长'] : ['短']) : []//signId是null时，不显示长短促，仅显示分值
            let long = [];
            let short = [];
            let onlyScore = -1
            if (type.length > 0) {
              (type[0] == '长' ? long : short).push({
                min: item.scoreMin,
                max: item.scoreMax,
                score: item.score,
              })
            } else {
              onlyScore = item.score
            }
            arr.push({
              name: item.masterName,
              masterId: item.masterId,
              type: type,
              long: long,
              short: short,
              onlyScore: onlyScore//是-1的时候说明不是仅展示分数的，是展示长短促的
            })
          }
        })
        this.mainData = arr;//一顿操作之后赋给页面主数据
        this.loading = false
      }).catch(err => {
        utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        this.loading = false
      })
      //本页有个写死的星级设定，从这里取
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchStar',
        params: {
          startTime: this.$route.query.id
        }
      }).then(res => {
        res.data.map(item => {
          let arr = []
          if (item.signId == 1) {
            arr.push
          }
        })
        this.starSetArr = res.data
      })
    },
  }
</script>

<style scoped lang="scss">
  .thisTitle {
    span:last-child {
      font-size: 15px;
      vertical-align: middle;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .thisIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .starBody {
    margin: 15px 0;
    .starSet {
      position: relative;
      .starSetTitle {
        padding: 10px 20px;
        background-color: #8299dc;
        color: white;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        margin-top: 10px;
        position: relative;
        .valueSetting {
          position: absolute;
          left: 134px;
          background: white;
          color: black;
          top: 5px;
          padding: 5px 20px;
          border-radius: 15px;
        }
      }
      .starContainer {
        padding: 20px;
        background-color: white;
        .wid100per {
          width: 100%;
        }
        & > div > div {
          display: inline-block;
        }
        .list {
          display: inline-block;
          width: 88%;
          margin-left: 40px;
          vertical-align: middle;
        }
        .wid130 {
          width: 130px;
          .range > span {
            padding: 0 5px
          }
        }
        .headPortrait {
          display: inline-block;
          .big {
            background-color: #829ada;
            color: white;
            width: 40px;
            height: 40px;
            line-height: 40px;
            vertical-align: middle;
          }
          .short {
            background-color: #81bc82;
          }
        }
      }
      .tag-item {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: white;
        border-radius: 50%;
        text-align: center;
        margin-right: 10px;
        color: #8cc18b;
        line-height: 20px;
      }
      .long {
        color: #839bdb;
      }
      .starSetTitleTag {
        color: white;
        position: absolute;
        top: 10px;
        right: 0;
        div {
          display: inline-block;
          margin-right: 30px;
        }
      }
      table {
        tr:first-child {
          background-color: #f8f8f8;
        }

        th {
          font-weight: normal;
          border: 1px solid #e6ebf5;
          &:first-child {
            padding: 8px
          }
        }

        td {
          border: 1px solid #e6ebf5;
          border-top: none;
          text-align: center;
          &:first-child {
            padding: 8px
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/zStar.vue